module.exports = __webpack_public_path__ + "img/mingpao.2d50b830.png";